// components/FaqModal.jsx
import { Stack, Text, Modal, Accordion } from "@mantine/core";
import faqs from "../utils/faqs.json"; // adjust path if needed

export function FaqModal({ opened, onClose }) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Frequently Asked Questions"
      size="xl"
      centered
      radius="lg" // rounded corners
      padding="lg" // more inner spacing
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
      styles={{
        content: {
          borderRadius: "16px",
          padding: "24px",
          boxShadow: "0 12px 40px rgba(0,0,0,0.12)",
          background: "linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)",
        },
        header: {
          marginBottom: "5px",
          fontWeight: 600,
        },
        title: {
          fontSize: "30px",
          fontWeight: 700,
          color: "#1e3a8a",
        },
        body: {
          paddingTop: "12px",
        },
      }}
    >
      <Stack spacing="lg">
        <Text size="sm" c="dimmed">
          Find answers to common questions about the registration process and
          what information we need.
        </Text>

        <Accordion variant="separated" radius="md">
          {faqs.map((category, categoryIndex) => (
            <div key={categoryIndex}>
              <Text fw={600} size="lg" c="blue.7" mb="md">
                {category.category}
              </Text>
              {category.questions.map((faq, faqIndex) => (
                <Accordion.Item
                  key={faqIndex}
                  value={`${categoryIndex}-${faqIndex}`}
                >
                  <Accordion.Control>
                    <Text fw={500}>{faq.question}</Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Text c="dimmed" size="sm" style={{ lineHeight: 1.6 }}>
                      {faq.answer}
                    </Text>
                  </Accordion.Panel>
                </Accordion.Item>
              ))}
            </div>
          ))}
        </Accordion>
      </Stack>
    </Modal>
  );
}
